export function escapeHtml(str) {
  if (!str) return ''
  const div = document.createElement('div')
  div.textContent = str
  return div.innerHTML
}

export function timeAgo(dateString) {
  const date = new Date(dateString)
  const now = new Date()
  const seconds = Math.floor((now - date) / 1000)

  if (seconds < 60) return '< 1 min'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours} godz.`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days} dn.`
  const months = Math.floor(days / 30)
  if (months < 12) return `${months} mies.`
  return `${Math.floor(months / 12)} r.`
}

export function formatDate(dateString, style = 'long') {
  if (!dateString) return ''
  const date = new Date(dateString)
  const options = style === 'short'
    ? { day: 'numeric', month: 'short', year: 'numeric' }
    : { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' }
  return date.toLocaleDateString('pl-PL', options)
}

export function avatarHtml(author, cssClass = 'forum-avatar forum-avatar--variable rounded') {
  if (!author) return ''
  if (author.avatar_url) {
    return `<img src="${escapeHtml(author.avatar_url)}" class="${cssClass}" alt="${escapeHtml(author.full_name)}">`
  }
  return `<div class="${cssClass} bg-secondary d-flex align-items-center justify-content-center text-white">${escapeHtml(author.initials || '?')}</div>`
}

export function paginationHtml(meta, baseUrl) {
  if (!meta || meta.total_pages <= 1) return ''
  const { current_page, total_pages } = meta
  let html = '<nav aria-label="Pagination"><ul class="pagination justify-content-center">'

  if (current_page > 1) {
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${current_page - 1}">&laquo;</a></li>`
  }

  const start = Math.max(1, current_page - 3)
  const end = Math.min(total_pages, current_page + 3)

  if (start > 1) {
    html += `<li class="page-item"><a class="page-link" href="#" data-page="1">1</a></li>`
    if (start > 2) html += '<li class="page-item disabled"><span class="page-link">...</span></li>'
  }

  for (let i = start; i <= end; i++) {
    const active = i === current_page ? ' active' : ''
    html += `<li class="page-item${active}"><a class="page-link" href="#" data-page="${i}">${i}</a></li>`
  }

  if (end < total_pages) {
    if (end < total_pages - 1) html += '<li class="page-item disabled"><span class="page-link">...</span></li>'
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${total_pages}">${total_pages}</a></li>`
  }

  if (current_page < total_pages) {
    html += `<li class="page-item"><a class="page-link" href="#" data-page="${current_page + 1}">&raquo;</a></li>`
  }

  html += '</ul></nav>'
  return html
}

export function participantAvatarsHtml(participants, totalCount, maxShow = 5) {
  if (!participants || participants.length === 0) return ''
  const shown = participants.slice(0, maxShow)
  const remaining = Math.max(0, (totalCount || participants.length) - maxShow)

  let html = '<div class="forum-participants">'
  shown.forEach(p => {
    const title = escapeHtml(p.full_name || '')
    if (p.avatar_url) {
      html += `<img src="${escapeHtml(p.avatar_url)}" class="forum-participant-avatar" alt="${title}" title="${title}">`
    } else {
      html += `<div class="forum-participant-avatar forum-participant-avatar--placeholder" title="${title}">${escapeHtml(p.initials || '?')}</div>`
    }
  })
  if (remaining > 0) {
    html += `<div class="forum-participant-avatar forum-participant-avatar--more" title="+${remaining}">+${remaining}</div>`
  }
  html += '</div>'
  return html
}

export function loadingSkeletonHtml(rows = 3) {
  let html = ''
  for (let i = 0; i < rows; i++) {
    html += `
      <div class="placeholder-glow mb-3">
        <span class="placeholder col-8"></span>
        <span class="placeholder col-4"></span>
        <span class="placeholder col-6"></span>
      </div>`
  }
  return html
}
